<template>
  <!-- 企业文化 -->
  <div class="culture_wrap">
    <div class="culture_wrap_inner">
      <div class="culture_container">
        <div class="title_box">
          {{cultureData.title}}
        </div>
        <div class="main_wrap">
          <div class="main_img_box">
            <img draggable="false" :src="cultureData.bg.bgUrl" :alt="cultureData.bg.alt" />
          </div>
          <div class="main_text_box">
            <div class="text_span" v-for="( content ) in cultureData.content" :key="content.id">
              <span class="span_title">{{content.title }}</span>
              <br/>
              <span class="span_text">{{ content.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import cultureLocalStoreData from "@/assets/mediaList/about.json"
  export default {
    data() {
      return {
        cultureData: cultureLocalStoreData.culture
      }
    },
    methods: {

    }
  }
</script>

<style scoped lang="scss">
.culture_wrap {
  width: 100%;
  height: 100%;
  padding: 4% 0 8%;
  margin: 0;
}
.culture_wrap_inner {
  width: 100%;
}
.culture_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 94%;
  max-width: 1280px;
  height: auto;
  margin: 0 auto;
  .title_box {
    width: auto;
    padding: 0 0 2% 0;
    margin: 0 auto;
    line-height: normal;
    font-size: 24px;
    text-align: center;
    font-weight: normal;
  }
  .main_wrap {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    color: rgba(102,102,102,1);
    line-height: 2.5;
    @media screen and (max-width: 768px) {
      flex-direction: column;
    }
    .main_img_box {
      @media screen and (max-width: 768px) {
        width: 100%;
      }
      width: 50%;
      img {
        width: 100%;
      }
    }
    .main_text_box {
      width: 50%;
      padding-left: 50px;
      @media screen and (max-width: 768px) {
        width: 100%;
        padding-left: 0;
      }
      .span_title {
        line-height: 2;
        color: #0555b6;
        font-size: 18px;
        font-weight: bold;
      }
      .span_text {
        line-height: 3;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
}
</style>
